import Setting from '../pageview/setting.vue'
import store from '../store/store'
import Sites from '../pageview/setting/sites'
import Gencode from '../pageview/setting/gencode'
import Filter from '../pageview/setting/filter'
import User from '../pageview/setting/user'
import Trans from '../pageview/setting/trans'
import Account from '../pageview/setting/account'
import AppUser from '../pageview/setting/appuser'
import CrowdSegmentation from '../pageview/setting/crowdSegmentation'
export default {
  path: 'setting',
  component: Setting,
  redirect: '/setting/sites',
  children: [
    {
      path: 'sites',
      component: Sites
    },
    {
      path: 'gencode',
      component: Gencode
    },
    {
      path: 'filter',
      component: Filter
    },
    {
      path: 'user',
      component: User
    },
    {
      path: 'trans',
      component: Trans
    },
    {
      path: 'crowdSegmentation',
      component: CrowdSegmentation
    },
    {
      path: 'account',
      component: Account
    },
    {
      path: 'appuser',
      component: AppUser
    }
  ].map(item => {
    item.beforeEnter = (to, from, next) => {
      const whiteListRe = /^\/(setting\/(gencode|filter|user|trans))/
      if (store.state.domainList.length === 0 && whiteListRe.test(to.path)) {
        next('/setting/sites')
      } else {
        next(true)
      }
    }
    return item
  })
}



// WEBPACK FOOTER //
// ./src/router/setting-router.js